import { Button } from '@/components/ui/button';
import { useMasterApprenticesStatStore } from '@/features/teacher-student-stat/store';
import { Download } from 'lucide-react';
import { FC, useState } from 'react';
import { exportTeacherStudentRepublicToExcel } from '../../../utils/exportTeacherStudentToExcel';
import { MasterApprenticesFilter } from '../../filter';
import { TeacherStudentHeader } from '../../header/Header';
import { TableRepublic } from './table/TableRepublic';

export const TeacherStudentStatRepublic: FC = () => {
  const { masterApprenticesRepublicResponse } = useMasterApprenticesStatStore();

  const [mastersTotal, setMastersTotal] = useState(0);
  const [apprenticesTotal, setApprenticesTotal] = useState(0);

  const hasRows = (masterApprenticesRepublicResponse?.rows.length ?? 0) > 0;

  const handleTotalsChange = (masters: number, apprentices: number) => {
    setMastersTotal(masters);
    setApprenticesTotal(apprentices);
  };

  const handleExport = async () => {
    if (masterApprenticesRepublicResponse) {
      await exportTeacherStudentRepublicToExcel(
        masterApprenticesRepublicResponse,
      );
    }
  };

  return (
    <div className="flex flex-col gap-4 p-8">
      <div className="flex items-center justify-between">
        <div className="flex flex-col w-full">
          <TeacherStudentHeader
            title="Respublika bo'yicha ustoz shogirdlar"
            isBack={false}
            mastersTotal={mastersTotal}
            apprenticesTotal={apprenticesTotal}
            isRepublic
          />
        </div>
      </div>
      <div className="flex items-center justify-between">
        <MasterApprenticesFilter />
        {hasRows && (
          <Button
            onClick={handleExport}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white"
          >
            <Download className="size-4" />
            Excel
          </Button>
        )}
      </div>
      <TableRepublic onTotalsChange={handleTotalsChange} />
    </div>
  );
};
